import React from 'react';
import { Col, Row } from 'reactstrap';


const Readstories = () => (
	<Col sm="12" xs="12" md="7" lg="7" style={{ overflow: 'hidden' }} >


		<Row className="readmore-box">
			<Col xs="4" sm="4" md="4" lg="4" >

				<img className="image-read-story" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/visit-stories.png" alt="Read more Stories" />


			</Col>
			<Col xs="8" sm="8" md="8" lg="8" className=" d-flex justify-content-center align-self-center">
				<p>Read stories of ours <br />visit <a href="https://medium.com/giveindia">here.</a> </p>


			</Col>
		</Row>


		<style global jsx>
			{
				`
		  .image-read-story{
    	 width: 100%;
       margin: auto;
      }

      				@media (max-width: 768px) {
      				.image-read-story{

      			 }
      				}
      .readmore-box{
        background-color: #f5f5f5;
        border: 1px solid #f5f5f5;
      font-weight: 400;
      margin-top:  15px;
      border-radius: 4px;
      padding: 1rem;
      };

			`
			}
		</style>
	</Col>


);

export default Readstories;
